import { Text, Theme, useStyles } from 'bold-ui'
import React, { CSSProperties } from 'react'

export interface HLabelProps {
  title: React.ReactNode
  children: React.ReactNode
  placeholder?: string
}

export function HLabel(props: HLabelProps) {
  const { title, children } = props

  const { classes } = useStyles(createStyles, props)

  return (
    <Text component='p'>
      <Text className={classes.title}>{title}</Text>
      <Text style={classes.content}>{children}</Text>
    </Text>
  )
}

HLabel.defaultProps = {
  placeholder: '—',
}

const createStyles = (theme: Theme, { placeholder }: HLabelProps) => ({
  title: {
    fontWeight: 'bold',
    marginRight: '0.375rem',
  } as CSSProperties,
  content: {
    '&:empty::before': {
      content: `"${placeholder}"`,
    },
  } as CSSProperties,
})
